import React from 'react';
import { IconProps } from '../icons/icons';

/**
 * NotificationAdd icon component
 *
 * @param props - SVG props
 */
export const NotificationAdd: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = '#000', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.33325 13.3334H7.99992C7.99992 14.0667 7.39992 14.6667 6.66659 14.6667C5.93325 14.6667 5.33325 14.0667 5.33325 13.3334ZM7.99992 6.00004C7.99992 7.74004 9.11325 9.22004 10.6666 9.77337V11.3334H11.9999V12.6667H1.33325V11.3334H2.66659V6.66671C2.66659 4.80671 3.93992 3.24004 5.66659 2.80004V2.33337C5.66659 1.78004 6.11325 1.33337 6.66659 1.33337C7.21992 1.33337 7.66659 1.78004 7.66659 2.33337V2.80004C8.13992 2.92004 8.57325 3.12671 8.96659 3.40004C8.35992 4.09337 7.99992 5.00671 7.99992 6.00004ZM14.6666 5.33337H12.6666V3.33337H11.3333V5.33337H9.33325V6.66671H11.3333V8.66671H12.6666V6.66671H14.6666V5.33337Z'
      fill={color}
    />
  </svg>
);

export default NotificationAdd;
